import { useContext, useEffect, useState } from "react";
import { ProductionAndSalesWithPaymentsDto } from "../../../../dtos/documents/ProductionAndSalesWithPayments/ProductionAndSalesWithPaymentsDto";
import { FormProvider, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { ProductionAndSalesWithPaymentsModel } from "../../../../models/Documents/ProductionAndSalesWithPayments/ProductionAndSalesWithPaymentsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import ProductionAndSalesWithPaymentsDetailSkeleton from "./ProductionAndSalesWithPaymentsDetailSkeleton";
import { ProductionAndSalesWithPaymentsDetailMain } from "./ProductionAndSalesWithPaymentsDetailMain";
import { ProductionAndSalesWithPaymentsDetailProducts } from "./ProductionAndSalesWithPaymentsDetailProducts";
import { ProductionAndSalesWithPaymentsDetailMaterials } from "./ProductionAndSalesWithPaymentsDetailMaterials";
import { ProductionAndSalesWIthPaymentsDetilSalary } from "./ProductionAndSalesWIthPaymentsDetilSalary";
import { ProductionAndSalesWithPaymentsDetailEmployeeEarnings } from "./ProductionAndSalesWithPaymentsDetailEmployeeEarnings";
import { ProductionAndSalesWithPaymentsDetailCosts } from "./ProductionAndSalesWithPaymentsDetailCosts";
import { ProductionAndSalesWithPaymentsAdditional } from "./ProductionAndSalesWithPaymentsAdditional";
import { ProductionAndSalesWithPaymentsAdvances } from "./ProductionAndSalesWithPaymentsAdvances";
import { ProductionAndSalesWithPaymentsDetailPayments } from "./ProductionAndSalesWithPaymentsDetailPayments";
import { ProductionAndSalesWIthPaymentsDetailFooter } from "./ProductionAndSalesWIthPaymentsDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: ProductionAndSalesWithPaymentsDto | null;
  modelUpdatedEvent: (newModel: ProductionAndSalesWithPaymentsDto) => void;
}

export const ProductionAndSalesWithPaymentsDetails = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ProductionAndSalesWithPaymentsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Return Of Goods From Customers");

  const watchProducts = watch("products");

  useEffect(() => {
    register("products");
    if (model) {
      setValue("createdDate", model.createdDate);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("status", model.status);
      setValue("comment", model.comment);
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("customerId", model.customerId);
      setValue("warehouseId", model.warehouseId);
      setValue("divisionId", model.divisionId);
      setValue("currencyId", model.currencyId);
      setValue("currencyRateId", model.currencyRateId);
      setValue("products", model.products);
      setValue("materials", model.materials);
      setValue("salary", model.salary);
      setValue("employeeEarnings", model.employeeEarnings);
      setValue("costs", model.costs);
      setValue("additionalProducts", model.additionalProducts);
      setValue("advances", model.advances);
      setValue("payment", model.payment);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: ProductionAndSalesWithPaymentsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newPrice * newProducts[index].quantity;
    setValue(`products.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    setValue(`products.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  if (!model) {
    return (
      <>
        <ProductionAndSalesWithPaymentsDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.ProductionAndSales.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Materials"} />
        <NFTab title={"Salary"} />
        <NFTab title={"Costs"} />
        <NFTab title={"Additional Products"} />
        <NFTab title={"Advances"} />
        <NFTab title={"Payment"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <ProductionAndSalesWithPaymentsDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <ProductionAndSalesWithPaymentsDetailProducts />
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <ProductionAndSalesWithPaymentsDetailMaterials />
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <ProductionAndSalesWIthPaymentsDetilSalary />

          <ProductionAndSalesWithPaymentsDetailEmployeeEarnings />
        </NFTabContainer>
        <NFTabContainer index={4} currentIndex={tabIndex}>
          <ProductionAndSalesWithPaymentsDetailCosts />
        </NFTabContainer>

        <NFTabContainer index={5} currentIndex={tabIndex}>
          <ProductionAndSalesWithPaymentsAdditional />
        </NFTabContainer>

        <NFTabContainer index={6} currentIndex={tabIndex}>
          <ProductionAndSalesWithPaymentsAdvances />
        </NFTabContainer>
        <NFTabContainer index={7} currentIndex={tabIndex}>
          <ProductionAndSalesWithPaymentsDetailPayments />
        </NFTabContainer>
      </div>
      <ProductionAndSalesWIthPaymentsDetailFooter />
    </FormProvider>
  );
};
